/** Approvals sahifasi lug'ati (uz). */
export default {
  title: "Tasdiqlashlar",
  subtitle: "{{scope}} · {{count}} ta qaroringizni kutmoqda",
  scope: { all: "Barcha filiallar", myBranch: "Mening filialim" },
  history: "Tarix",
  backToPending: "Kutilayotganlarga qaytish",
  kind: { hire: "Yollash", transfer: "O'tkazish", expense: "Xarajat", bonus: "Bonus" },
  kinds: { hire: "Yollashlar", transfer: "O'tkazishlar", expense: "Xarajatlar", bonus: "Bonuslar" },
  hireInfo: "Yollash hisobot, KPI va bonuslarda faqat tasdiqlangandan keyin hisobga olinadi.",
  loadFailed: "Tasdiqlashlarni yuklab bo'lmadi.",
  empty: {
    history: "Hali qarorlar yo'q",
    historyDesc: "Qaror qilingan so'rovlar shu yerda ko'rinadi.",
    pending: "Kutilayotgan {{kind}} yo'q",
    pendingDesc: "Yangi so'rovlar shu yerga real vaqtda keladi.",
  },
  pagination: "so'rov",
  recent: { title: "So'nggi qarorlar", none: "Hali qaror qilinmagan", by: "{{who}} tomonidan" },
  toast: {
    approved: "Tasdiqlandi: {{name}}",
    rejected: "Rad etildi: {{name}}",
    alreadyDecided: "Allaqachon qaror qilingan yoki o'zgargan",
    listRefreshed: "Ro'yxat yangilandi.",
    saveFailed: "Qarorni saqlab bo'lmadi",
    checkConnection: "Internet aloqasini tekshirib, qayta urinib ko'ring.",
  },
  columns: {
    driver: "Haydovchi",
    recruiter: "Recruiter",
    carrierJob: "Carrier / Vakansiya",
    startDate: "Boshlash sanasi",
    evidence: "Dalil",
    submitted: "Yuborilgan",
    decision: "Qaror",
    actions: "Amallar",
    fromTo: "Kimdan → Kimga",
    requestedBy: "So'rovchi",
    note: "Izoh",
    branch: "Filial",
  },
  noConfirmation: "Carrier tasdig'i yo'q",
  pool: "umumiy baza",
  markedBy: "{{who}} belgilagan",
  approve: {
    title: "Tasdiqlash: {{what}}",
    hireHint: "Tasdiqlangandan keyin yollash hisobot, KPI va recruiter bonusida hisobga olinadi. Saqlanish tekshiruvlari (30/60/90 kun) avtomatik rejalashtiriladi.",
    note: "Izoh (ixtiyoriy)",
    notePlaceholder: "Carrier emaili orqali tasdiqlangan…",
    fee: "{{carrier}} to'lovi ($)",
    feeHint: "Carrier shu driver uchun to'laydigan summa. Keyin Budjet → Carrier to'lovlarida o'zgartirish mumkin; pul tushganda o'sha yerda yoziladi.",
  },
  reject: {
    title: "Rad etish: {{what}}",
    reason: "Sabab",
    chooseReason: "Sababni tanlang…",
    reasonPlaceholder: "Nega rad etilmoqda?",
    returnTo: "Haydovchini qaytarish holati",
    comment: "Recruiter uchun izoh",
    commentPlaceholder: "Carrier'dan boshlash sanasini email orqali tasdiqlashni so'rang",
    footnote: "Recruiterga bildirishnoma boradi. Hech narsa o'chirilmaydi; qaror jurnalga yoziladi.",
    rejectHire: "Yollashni rad etish",
    reasonRequired: "Sabab majburiy.",
  },
};
